export default __webpack_public_path__ + "static/media/logo-madrasa.48873c9c.png";